import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWifi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 5.375c2-1.75 5.125-2.625 8.25-2.625s6.25.875 8.25 2.625m-14 3.437C5.75 7.438 7.875 6.75 10 6.75s4.25.687 5.75 2.062m-9.25 3.25c1-.874 2.25-1.312 3.5-1.312s2.5.438 3.5 1.313M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgWifi);
export { ForwardRef as ReactComponent };
